import { MouseEvent } from "react";

export const setTruncatedTitle = (event: MouseEvent<HTMLElement>) => {
    const element = event.currentTarget;
    const isMultiline = getComputedStyle(element).whiteSpace !== "nowrap";
    const isTruncated =
        Math.ceil(element.getBoundingClientRect().width) < element.scrollWidth ||
        (isMultiline && element.clientHeight < element.scrollHeight);

    element.title = isTruncated ? element.textContent ?? "" : "";
};

export const hasClassName = (className: string) => (element: HTMLElement) =>
    element.classList.contains(className);

export const getElementWidth = (element: HTMLElement) =>
    element.getBoundingClientRect().width;

export const getElementBottom = (element: HTMLElement) =>
    element.offsetTop + element.offsetHeight;
